const api_srv = import("./apiSrv");
const auth_srv = import("./authSrv");
const quotation_srv = import("./quotationSrv")
const appointment_srv = import("./appointmentSrv")

const error_handler = import("./errorHandler");

export { api_srv, error_handler, appointment_srv };
